import { AppUser, IField } from '@eventr/common'
import { Search, TextInputField } from '@eventr/common-storybook'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { IEditComponent } from '../../../data/Data'
import i18n from '../../../i18n/i18next'

import { bs, useBoundStore } from '../../../state/bound.store'
import { useEditSectionContext } from '../editSectionProvider'
interface IUserSelectionFieldProps {
    field: IField
    _id?: string
    editComponent?: IEditComponent
}

export const UserSelectionField = ({
    field,
    _id,
    editComponent,
}: IUserSelectionFieldProps) => {
    const { pathname } = useLocation()
    const { getValue } = useEditSectionContext()

    const [state, setState] = useState<string>()

    useEffect(() => {
        const initFieldValue = getValue(field, _id)
        const _users: AppUser[] = []
        const tagsDep: string[] = []
        const tagsGroup: string[] = []
        initFieldValue.forEach((u) => {
            if (u && u.type === 'User') {
                const user = useBoundStore
                    .getState()
                    .getUserFromID(Number.parseInt(u.option?.toString()))

                const inList = _users?.some((u) => {
                    return u?.id === user?.id
                })
                if (user && !inList) {
                    _users.push(user)
                }
            }
            if (u && u.type === 'Department') {
                tagsDep.push(u.option?.toString())
            }
            if (u && u.type === 'Group') {
                tagsGroup.push(u.option?.toString())
            }
        })
        const tagUsers = useBoundStore
            .getState()
            .getUsersWithTags(tagsDep, tagsGroup)
        // only add users that are not already in the list
        tagUsers.forEach((u) => {
            if (!_users?.find((user) => user.id === u.id)) {
                _users.push(u)
            }
        })
        setState(
            _users
                .map(
                    (user, rowId) =>
                        `${bs().getNameFormatted(user)}${
                            rowId < _users.length - 1 ? ', ' : ''
                        }`
                )
                .join('')
        )
    }, [field, _id, getValue])

    return (
        <TextInputField
            id={field.field_name}
            value={state}
            iconLeft={<Search />}
            readOnly
            onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                window.pushPath(
                    changeSubpage(
                        editComponent.settings?.subPage || 0,
                        pathname
                    )
                )
            }}
            fieldLabel={i18n.t(`edit-itinerary.fields.${field.id}`)}
        />
    )
}

const changeSubpage = (subPage: number, pathname: string) => {
    const path = pathname.split('/')
    path[5] = subPage.toString()
    return path.join('/')
}
